var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 363.2 363.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 7.2C62.6 7.2 45.8 24 45.8 44.4V318c0 20.4 16.8 37.2 37.2 37.2h197.2c20.4 0 37.2-16.8 37.2-37.2V83.6L249.8 7.2H83z",
    fill: "#f4f4f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.8 83.6h67.6L249.8 7.2z",
    fill: "#c6c6c6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#191919"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.8 80c-.4-.4-.4-.8-.8-1.2L255 2.4h0c-.4-.4-1.2-.8-1.6-1.2-.4 0-.4-.4-.8-.4-.8-.4-2-.8-2.8-.8H83a44.73 44.73 0 0 0-44.8 44.8v273.6A44.73 44.73 0 0 0 83 363.2h197.2a44.73 44.73 0 0 0 44.8-44.8V83.6c0-.8-.4-2-.4-2.8-.4-.4-.4-.8-.8-.8zM257 26.8L301 76h-44V26.8zM310.2 318c0 16.4-13.2 29.6-29.6 29.6H83c-16.4 0-29.6-13.2-29.6-29.6V44.4C53.4 28 66.6 14.8 83 14.8h159.2v68.8c0 4 3.2 7.6 7.6 7.6h60.4V318zM157.8 76h-66c-4 0-7.6 3.2-7.6 7.6s3.2 7.6 7.6 7.6h66c4 0 7.6-3.2 7.6-7.6s-3.6-7.6-7.6-7.6zm0 196h-66c-4 0-7.6 3.2-7.6 7.6 0 4 3.2 7.6 7.6 7.6h66c4 0 7.6-3.2 7.6-7.6-.4-4-3.6-7.6-7.6-7.6z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 36.8
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 73.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 110.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M268.2 125.6h-176c-4 0-7.6 3.2-7.6 7.6 0 4 3.2 7.6 7.6 7.6h176c4 0 7.6-3.2 7.6-7.6-.4-4-3.6-7.6-7.6-7.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherIcon);
export default __webpack_public_path__ + "static/media/other-icon.fdd0731ff8cfdc8002c96408d03bbe53.svg";
export { ForwardRef as ReactComponent };